import {
  doesCookieExist,
  deleteCookie,
  getCookie,
  setCookie,
} from "common/utils/cookie";

const TOKEN_COOKIE = "token";

export function hasTokenCookie() {
  return doesCookieExist(TOKEN_COOKIE);
}

export function getTokenCookie() {
  const token = getCookie(TOKEN_COOKIE);
  return token !== "" ? token : null;
}

export function setTokenCookie(value: string) {
  setCookie(TOKEN_COOKIE, value, "Max-Age=7200; Path=/; SameSite=Strict");
}

export function deleteTokenCookie() {
  deleteCookie(TOKEN_COOKIE, "Path=/");
}
